const LoadingCircleCompleted = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 0 34.9264 0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5ZM7.01588 22.5C7.01588 31.0516 13.9484 37.9841 22.5 37.9841C31.0516 37.9841 37.9841 31.0516 37.9841 22.5C37.9841 13.9484 31.0516 7.01588 22.5 7.01588C13.9484 7.01588 7.01588 13.9484 7.01588 22.5Z"
        fill="#006DFF"
      />
    </svg>
  );
};
export default LoadingCircleCompleted;
